/**
 * @generated SignedSource<<f9fba255542475c6fa1a5a69a78fe7a5>>
 * @relayHash cf8d64919bb31105ae5e9ebbc64d2341
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID cf8d64919bb31105ae5e9ebbc64d2341

import { ConcreteRequest } from 'relay-runtime';
export type deFavoriteAgentsByPatientQuery$variables = {
  patientId: string;
};
export type deFavoriteAgentsByPatientQuery$data = {
  readonly patientById: {
    readonly favoriteAgentUserNames: ReadonlyArray<string>;
  } | null;
};
export type deFavoriteAgentsByPatientQuery = {
  response: deFavoriteAgentsByPatientQuery$data;
  variables: deFavoriteAgentsByPatientQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "patientId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "patientId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "favoriteAgentUserNames",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "deFavoriteAgentsByPatientQuery",
    "selections": [
      {
        "alias": "patientById",
        "args": (v1/*:: as any*/),
        "concreteType": "de_Patient",
        "kind": "LinkedField",
        "name": "de_patientById",
        "plural": false,
        "selections": [
          (v2/*:: as any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "deFavoriteAgentsByPatientQuery",
    "selections": [
      {
        "alias": "patientById",
        "args": (v1/*:: as any*/),
        "concreteType": "de_Patient",
        "kind": "LinkedField",
        "name": "de_patientById",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "cf8d64919bb31105ae5e9ebbc64d2341",
    "metadata": {},
    "name": "deFavoriteAgentsByPatientQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "ccdd6ed4b62bef01ce587cd4515408a3";

export default node;
